import $ from 'jquery';

$(window).on('load', () => {
  const tabsHidden = $('.overview__hidden');
  const tabsWrapper = $('.overview__tabs');
  const content = $('.overview__wrapper');
  if (tabsHidden.length <= 1) {
    tabsWrapper.remove();
    $('.overview__title').addClass('bold');
  } else {
    for (let i = 0; i < tabsHidden.length; i++) {
      const newTab = document.createElement('button');
      newTab.classList.add('overview__tabs-item');
      newTab.setAttribute('data-tab', i);
      newTab.setAttribute('type', 'button');
      newTab.textContent = tabsHidden[i].textContent;
      tabsWrapper.append(newTab);
      tabsHidden[i].remove();
    }

    const tabs = $('.overview__tabs-item');
    tabs.first().addClass('active');

    tabs.each((ind, el) => {
      $(el).on('click', () => {
        tabs.removeClass('active');
        $(el).addClass('active');
        content.hide();
        $(`.overview__wrapper[data-tab=${ind}]`).show();
      });
    });

    content.each((ind, el) => {
      $(el).attr('data-tab', ind);
    });
  }
});
